var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "exam", attrs: { id: "train" } },
    [
      _c("div", { staticClass: "left" }, [
        _c("div", { staticClass: "exam-con" }, [
          _c(
            "div",
            { staticClass: "content" },
            [
              _vm._l(_vm.paperQuestion, function(l, key) {
                return [
                  _c(
                    "div",
                    { staticClass: "type" },
                    [
                      _c("div", { staticClass: "title" }, [
                        _c("p", [
                          _vm._v(
                            _vm._s(_vm.getNum(key)) +
                              "、" +
                              _vm._s(l.title) +
                              "（共" +
                              _vm._s(l.questionRecordFullList.length) +
                              "题，每题" +
                              _vm._s(l.eachScore) +
                              "分）"
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm._l(l.questionRecordFullList, function(q, index) {
                        return _c(
                          "div",
                          { staticClass: "list" },
                          [
                            q.answerRecord
                              ? [
                                  q.answerRecord.questionType == "BlankFilling"
                                    ? [
                                        _c(
                                          "p",
                                          {
                                            attrs: {
                                              id: _vm.savelist[key][index].num
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.savelist[key][index].num
                                              ) + "、\n                    "
                                            ),
                                            _vm._l(
                                              q.answerRecord.question
                                                .questionStem,
                                              function(s, k) {
                                                return [
                                                  _c("span", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.replaceNToBr(s)
                                                      )
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("el-input", {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          k !=
                                                          q.answerRecord
                                                            .question
                                                            .questionStem
                                                            .length -
                                                            1,
                                                        expression:
                                                          "k != q.answerRecord.question.questionStem.length - 1"
                                                      }
                                                    ],
                                                    attrs: {
                                                      placeholder: "请输入答案"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.savelist[key][index]
                                                          .tjkAnswerString[k],
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.savelist[key][
                                                            index
                                                          ].tjkAnswerString,
                                                          k,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "savelist[key][index].tjkAnswerString[k]"
                                                    }
                                                  })
                                                ]
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ]
                                    : q.answerRecord.questionType ==
                                      "BlankChoice"
                                    ? [
                                        _c(
                                          "p",
                                          {
                                            attrs: {
                                              id: _vm.savelist[key][index].num
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.savelist[key][index].num
                                              ) + "、\n                    "
                                            ),
                                            _vm._l(
                                              q.answerRecord.question
                                                .questionStem,
                                              function(s, k) {
                                                return [
                                                  _c("span", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.replaceNToBr(s)
                                                      )
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          k !=
                                                          q.answerRecord
                                                            .question
                                                            .questionStem
                                                            .length -
                                                            1,
                                                        expression:
                                                          "k != q.answerRecord.question.questionStem.length - 1"
                                                      },
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.savelist[key][
                                                            index
                                                          ].tjkAnswerString[k],
                                                        expression:
                                                          "savelist[key][index].tjkAnswerString[k]"
                                                      }
                                                    ],
                                                    staticClass: "answer-input",
                                                    attrs: {
                                                      type: "text",
                                                      size: "1",
                                                      maxlength: "1",
                                                      placeholder: "请输入答案"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.savelist[key][index]
                                                          .tjkAnswerString[k]
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.savelist[key][
                                                            index
                                                          ].tjkAnswerString,
                                                          k,
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ]
                                    : [
                                        _c(
                                          "p",
                                          {
                                            attrs: {
                                              id: _vm.savelist[key][index].num
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.savelist[key][index].num
                                              ) + "、"
                                            ),
                                            _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.replaceNToBr(
                                                    q.answerRecord.question
                                                      .questionStemString
                                                  )
                                                )
                                              }
                                            })
                                          ]
                                        )
                                      ],
                                  _vm._v(" "),
                                  q.answerRecord.question.imageUrlList
                                    ? _c(
                                        "p",
                                        [
                                          _vm._l(
                                            q.answerRecord.question
                                              .imageUrlList,
                                            function(i) {
                                              return [
                                                i != ""
                                                  ? _c("img", {
                                                      staticClass: "s-img",
                                                      attrs: { src: i },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.clickImg(
                                                            $event
                                                          )
                                                        }
                                                      }
                                                    })
                                                  : _vm._e()
                                              ]
                                            }
                                          )
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  q.answerRecord.questionType == "SingleChoice"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "answer" },
                                          _vm._l(
                                            q.answerRecord.question.choices,
                                            function(value, k) {
                                              return _c(
                                                "p",
                                                [
                                                  _c(
                                                    "el-radio",
                                                    {
                                                      attrs: { label: k },
                                                      model: {
                                                        value:
                                                          _vm.savelist[key][
                                                            index
                                                          ].tjkAnswerString,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.savelist[key][
                                                              index
                                                            ],
                                                            "tjkAnswerString",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "savelist[key][index].tjkAnswerString"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(k) +
                                                          "、" +
                                                          _vm._s(value)
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      ]
                                    : q.answerRecord.questionType ==
                                      "MultipleChoice"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "answer" },
                                          [
                                            _c(
                                              "el-checkbox-group",
                                              {
                                                model: {
                                                  value:
                                                    _vm.savelist[key][index]
                                                      .tjkAnswerString,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.savelist[key][index],
                                                      "tjkAnswerString",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "savelist[key][index].tjkAnswerString"
                                                }
                                              },
                                              _vm._l(
                                                q.answerRecord.question.choices,
                                                function(value, k) {
                                                  return _c(
                                                    "p",
                                                    [
                                                      _c(
                                                        "el-checkbox",
                                                        { attrs: { label: k } },
                                                        [
                                                          _vm._v(
                                                            _vm._s(k) +
                                                              "、" +
                                                              _vm._s(value)
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    : q.answerRecord.questionType ==
                                      "TrueOrFalse"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "answer" },
                                          [
                                            _c(
                                              "el-radio-group",
                                              {
                                                model: {
                                                  value:
                                                    _vm.savelist[key][index]
                                                      .tjkAnswerString,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.savelist[key][index],
                                                      "tjkAnswerString",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "savelist[key][index].tjkAnswerString"
                                                }
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  [
                                                    _c(
                                                      "el-radio",
                                                      {
                                                        attrs: { label: true }
                                                      },
                                                      [_vm._v("正确")]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "p",
                                                  [
                                                    _c(
                                                      "el-radio",
                                                      {
                                                        attrs: { label: false }
                                                      },
                                                      [_vm._v("错误")]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    : q.answerRecord.questionType ==
                                      "BlankChoice"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "answer" },
                                          _vm._l(
                                            q.answerRecord.question.choices,
                                            function(value, k) {
                                              return _c("p", [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(k) +
                                                      "、" +
                                                      _vm._s(value)
                                                  )
                                                ])
                                              ])
                                            }
                                          ),
                                          0
                                        )
                                      ]
                                    : q.answerRecord.questionType ==
                                      "ShortAnswer"
                                    ? [
                                        _c("div", { staticClass: "answer" }, [
                                          _c("p", [
                                            _vm._v("答案："),
                                            _c("textarea", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.savelist[key][index]
                                                      .tjkAnswerString,
                                                  expression:
                                                    "savelist[key][index].tjkAnswerString"
                                                }
                                              ],
                                              staticClass:
                                                "answer-input shortanswer",
                                              domProps: {
                                                value:
                                                  _vm.savelist[key][index]
                                                    .tjkAnswerString
                                              },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    _vm.savelist[key][index],
                                                    "tjkAnswerString",
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            })
                                          ])
                                        ])
                                      ]
                                    : _vm._e()
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      })
                    ],
                    2
                  )
                ]
              })
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "right" }, [
        _c("div", { staticClass: "count" }, [
          _c("h2", [_vm._v("统计")]),
          _vm._v(" "),
          _c("div", { staticClass: "useTime" }, [
            _c("p", [_vm._v("距自动交卷时间")]),
            _vm._v(" "),
            _c("span", { staticClass: "blue" }, [_vm._v(_vm._s(_vm.time))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "useTime" }, [
            _c("p", { staticClass: "txt" }, [
              _vm._v("满分100分，" + _vm._s(_vm.passScore) + "分及格")
            ])
          ]),
          _vm._v(" "),
          _c(
            "ul",
            _vm._l(_vm.list, function(s) {
              return _c(
                "li",
                { class: { active3: _vm.getClass(s.tjkAnswerString) } },
                [
                  _c("a", { attrs: { href: "#" + s.num } }, [
                    _vm._v(_vm._s(s.num))
                  ])
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "btn" }, [
            _c("div", { staticClass: "hold", on: { click: _vm.exitExam } }, [
              _vm._v("返回学习")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "submit", on: { click: _vm.saveExam } }, [
              _vm._v("提交试卷")
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "",
            visible: _vm.completeDialogVisible,
            width: "360px",
            "close-on-click-modal": false,
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.completeDialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.state == "passed",
                  expression: "state == 'passed'"
                }
              ],
              staticClass: "correct_img"
            },
            [
              _c("img", {
                attrs: {
                  src: require("../../assets/images/correct.png"),
                  alt: ""
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.state == "failed",
                  expression: "state == 'failed'"
                }
              ],
              staticClass: "correct_img"
            },
            [
              _c("img", {
                attrs: {
                  src: require("../../assets/images/icon_yiahan.png"),
                  alt: ""
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.state == "passed",
                  expression: "state == 'passed'"
                }
              ],
              staticClass: "score"
            },
            [_vm._v(_vm._s(_vm.score) + "分")]
          ),
          _vm._v(" "),
          _vm.state == "passed"
            ? _c("div", { staticClass: "state_text1" }, [_vm._v("恭喜你！")])
            : _vm._e(),
          _vm._v(" "),
          _vm.state == "failed"
            ? _c("div", { staticClass: "state_text1" }, [_vm._v("很遗憾！")])
            : _vm._e(),
          _vm._v(" "),
          _vm.state == "failed"
            ? _c("div", { staticClass: "state_text1_1" }, [
                _vm._v("你未通过测试检验")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.state == "passed" &&
          _vm.knowledgestate == "jumpToCourse" &&
          (_vm.Graduation == "false" || _vm.Graduation == "") &&
          _vm.tabstate == null
            ? _c("div", { staticClass: "state_text2 newtext" }, [
                _vm._v("你已通过“\n      "),
                _c("span", { staticClass: "spanclass" }, [
                  _vm._v(_vm._s(_vm.knowledgename))
                ]),
                _vm._v("\n      ”"),
                _c("br"),
                _vm._v("接下来，请进行下一个课程的"),
                _vm.Coursestate == "Study"
                  ? _c("span", [_vm._v("学习")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.Coursestate == "Practice"
                  ? _c("span", [_vm._v("练习")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.Coursestate == "Exam"
                  ? _c("span", [_vm._v("测试")])
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.state == "passed" &&
          _vm.tabstate == "noNextTab" &&
          _vm.trainFlag == "theory"
            ? _c("div", { staticClass: "state_text2 newtext" }, [
                _vm._v("你已通过“"),
                _c("span", { staticClass: "spanclass" }, [_vm._v("理论考试")]),
                _vm._v("”")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.state == "passed" &&
          _vm.tabstate == "noNextTab" &&
          _vm.trainFlag != "theory"
            ? _c("div", { staticClass: "state_text2 newtext" }, [
                _vm._v("你已通过“"),
                _c("span", { staticClass: "spanclass" }, [
                  _vm._v(_vm._s(_vm.categoryName))
                ]),
                _vm._v("”")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.state == "passed" &&
          _vm.knowledgestate == "jumpToKnowledge" &&
          _vm.Graduation == "true"
            ? _c("div", { staticClass: "state_text2 newtext" }, [
                _vm._v("\n      你已通过“"),
                _c("span", [_vm._v(_vm._s(_vm.Coursename))]),
                _vm._v("”")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.state == "passed" && _vm.tabstate == 0 && _vm.Graduation == "true"
            ? _c("div", { staticClass: "state_text2 newtext" }, [
                _vm._v(
                  "\n      你已通过语音" +
                    _vm._s(_vm.categoryName) +
                    "全部课程的学习"
                ),
                _c("br"),
                _vm._v("并获得“" + _vm._s(_vm.huizhang) + "”徽章"),
                _c("br"),
                _vm._v("现在可以领取语音任务了")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.state == "passed" &&
          _vm.tabstate == "noNextTab" &&
          _vm.Graduation == "true"
            ? _c("div", { staticClass: "state_text2 newtext" }, [
                _vm._v(
                  "\n      你已通过语音" +
                    _vm._s(_vm.categoryName) +
                    "全部课程的学习"
                ),
                _c("br"),
                _vm._v("并获得“" + _vm._s(_vm.huizhang) + "”徽章"),
                _c("br"),
                _vm._v("现在可以领取语音任务了")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.state == "passed" &&
          _vm.knowledgestate == "jumpToCourse" &&
          _vm.tabstate == "noNextTab" &&
          (_vm.Graduation == "false" || _vm.Graduation == "") &&
          _vm.trainFlag == "theory"
            ? _c("div", { staticClass: "state_text2 newtext" }, [
                _vm._v("\n      接下来请进行下一个课程的学习")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.state == "passed" &&
          _vm.knowledgestate == "jumpToCourse" &&
          _vm.tabstate == "noNextTab" &&
          (_vm.Graduation == "false" || _vm.Graduation == "") &&
          _vm.trainFlag != "theory"
            ? _c("div", { staticClass: "state_text2 newtext" }, [
                _vm._v("\n      你已通过全部课程的学习"),
                _c("br"),
                _vm._v("现在可以领取任务了")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.state == "passed" &&
          _vm.knowledgestate == "jumpToCourse" &&
          _vm.tabstate == "hasNextTab"
            ? _c("div", { staticClass: "state_text2 newtext" }, [
                _vm._v("你已通过“\n      "),
                _c("span", { staticClass: "spanclass" }, [
                  _vm._v(_vm._s(_vm.categoryName))
                ]),
                _vm._v("\n      ” "),
                _c("br"),
                _c("br"),
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$route.query.trainFlag == "fbtTrain"
                        ? "接下来，请完善你的在线经验和意向班次"
                        : "接下来，请进行下一阶段的学习"
                    ) +
                    "\n    "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div"),
          _vm._v(" "),
          _vm.state == "failed"
            ? _c("div", { staticClass: "failed" }, [
                _vm._v("测试分数："),
                _c("span", [_vm._v(_vm._s(_vm.score))]),
                _vm._v("分；剩余测试次数："),
                _c("span", [_vm._v(_vm._s(_vm.times))]),
                _vm._v("次")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div"),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("div", { staticClass: "button_box1" }, [
                _vm.state == "passed" &&
                _vm.tabstate == "noNextTab" &&
                _vm.trainFlag != "theory"
                  ? _c(
                      "div",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.isreturn }
                      },
                      [_vm._v("我知道了")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.state == "passed" &&
                _vm.tabstate == "noNextTab" &&
                _vm.trainFlag == "theory"
                  ? _c(
                      "div",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.goindex }
                      },
                      [_vm._v("去报名并参加实操培训\n        ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.state == "passed" &&
                _vm.knowledgestate == "jumpToCourse" &&
                _vm.tabstate == null &&
                _vm.Coursestate != "Study"
                  ? _c(
                      "div",
                      {
                        staticClass: "out_button_3",
                        attrs: { type: "primary" },
                        on: { click: _vm.determine }
                      },
                      [
                        _vm._v("去"),
                        _vm.Coursestate == "Practice"
                          ? _c("span", [_vm._v("练习")])
                          : _vm._e(),
                        _vm.Coursestate == "Exam"
                          ? _c("span", [_vm._v("测试")])
                          : _vm._e()
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.state == "passed" &&
                _vm.knowledgestate == "jumpToCourse" &&
                _vm.tabstate == null &&
                _vm.Coursestate == "Study"
                  ? _c(
                      "div",
                      {
                        staticClass: "out_button_3",
                        attrs: { type: "primary" },
                        on: { click: _vm.determine }
                      },
                      [_vm._v("继续学习")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.state == "passed" &&
                _vm.knowledgestate == "jumpToCourse" &&
                _vm.tabstate == "hasNextTab" &&
                _vm.trainFlag == "theory"
                  ? _c(
                      "div",
                      {
                        staticClass: "out_button_3",
                        attrs: { type: "primary" },
                        on: { click: _vm.goindex }
                      },
                      [_vm._v("去报名并参加" + _vm._s(_vm.nextcategoryName))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.state == "passed" &&
                _vm.knowledgestate == "jumpToCourse" &&
                _vm.trainFlag != "theory" &&
                _vm.trainFlag == "fbtTrain"
                  ? _c(
                      "div",
                      {
                        staticClass: "out_button_3",
                        attrs: { type: "primary" },
                        on: { click: _vm.goUpdateExp }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.fbtBadge || _vm.state == "passed"
                              ? "修改经验"
                              : "去完善"
                          )
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.state == "passed" &&
                _vm.knowledgestate == "jumpToCourse" &&
                _vm.tabstate == "hasNextTab" &&
                _vm.trainFlag != "theory" &&
                _vm.trainFlag != "fbtTrain"
                  ? _c(
                      "div",
                      {
                        staticClass: "out_button_3",
                        attrs: { type: "primary" },
                        on: { click: _vm.goindex }
                      },
                      [_vm._v("我知道了")]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.state == "failed"
                ? _c("div", { staticClass: "button_box" }, [
                    _c(
                      "div",
                      { staticClass: "out_button_1", on: { click: _vm.again } },
                      [_vm._v("继续测试")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "out_button_2",
                        on: { click: _vm.relearn }
                      },
                      [_vm._v("重新学习")]
                    ),
                    _vm._v(" "),
                    _vm.showExamError
                      ? _c(
                          "div",
                          {
                            staticClass: "out_button_2",
                            staticStyle: { "margin-left": "10px" },
                            on: { click: _vm.goCuotiji }
                          },
                          [_vm._v("错题集")]
                        )
                      : _vm._e()
                  ])
                : _vm._e()
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.showImg
        ? _c("zoom-img", {
            attrs: { imgSrc: _vm.imgSrc },
            on: { clickit: _vm.viewImg }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a8ae64a4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8ae64a4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/train/examDetail.vue
// module id = 1587
// module chunks = 0